import React, { useState, useCallback, useEffect } from 'react';

import { hasRoles, DOWNLOAD_REPORTS_ROLES } from '../../../util/RoleUtil';

import { retrieveStudyDropdownsSpecific } from '../../../services/StudyService';

import { DataCapture } from './data-capture/DataCapture';
import { SDVCapture } from './sdv-capture/SDVCapture';
import { LiveScheduler } from './live-scheduler/LiveScheduler';
import { PageTracking } from './page-tracking/PageTracking';

import './DataManagement.css';

export const DataManagement = ({ context, setSpinnerText, showToaster }) => {
  const [activeTab, setActiveTab] = useState('data-capture');
  const [studies, setStudies] = useState([]);

  const retrieveStudies = useCallback(async () => {
    setSpinnerText('Retrieving Studies');
    const [studyData, studyError] = await retrieveStudyDropdownsSpecific(context.username);
    if (studyData) {
      if (studyData.responseStatus === 'Success') {
        const formattedStudies = studyData.dropdownStudyVOs.map((study) => ({
          label: study.name,
          value: study,
        }));
        setStudies(formattedStudies);
      } else {
        showToaster(studyData);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: studyError.message,
      });
    }
    setSpinnerText(undefined);
  }, [context, setSpinnerText, showToaster]);

  useEffect(() => {
    retrieveStudies();
  }, [retrieveStudies]);

  const canDownloadReports = hasRoles(context, DOWNLOAD_REPORTS_ROLES);

  const tabs = new Map();
  tabs.set(
    'data-capture',
    <DataCapture
      context={context}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
      studies={studies}
      downloadEnabled={canDownloadReports}
    />
  );
  tabs.set(
    'sdv-capture',
    <SDVCapture
      context={context}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
      studies={studies}
      downloadEnabled={canDownloadReports}
    />
  );
  tabs.set(
    'live-scheduler',
    <LiveScheduler
      context={context}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
      downloadEnabled={canDownloadReports}
    />
  );
  tabs.set(
    'page-tracking',
    <PageTracking
      context={context}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
      downloadEnabled={canDownloadReports}
    />
  );

  return (
    <section className="data-management">
      <section className="data-management-tabs">
        <button
          className={'data-management-tab data-capture ' + (activeTab === 'data-capture' ? 'active-tab' : null)}
          onClick={() => setActiveTab('data-capture')}
        >
          Data Capture
        </button>
        <button
          className={'data-management-tab sdv-capture ' + (activeTab === 'sdv-capture' ? 'active-tab' : null)}
          onClick={() => setActiveTab('sdv-capture')}
        >
          SDV Capture
        </button>
        <button
          className={'data-management-tab live-scheduler ' + (activeTab === 'live-scheduler' ? 'active-tab' : null)}
          onClick={() => setActiveTab('live-scheduler')}
        >
          Live Scheduler
        </button>
        <button
          className={'data-management-tab page-tracking ' + (activeTab === 'page-tracking' ? 'active-tab' : null)}
          onClick={() => setActiveTab('page-tracking')}
        >
          Page Tracking
        </button>
      </section>
      <section className={'data-management-content ' + activeTab}>{tabs.get(activeTab)}</section>
    </section>
  );
};
